import { useEffect, useRef, useState } from 'react';
import { BsEye, BsEyeSlash } from 'react-icons/bs';

const PasswordInput = ({
  value,
  onChange,
  name = 'password',
  placeholder = 'Enter your password',
  showIcon = true,
}) => {
  const passwordRef = useRef();

  const [show, setShow] = useState(false);

  useEffect(() => {
    // if (passwordRef.current) {
    //   passwordRef.current.removeAttribute('autocomplete');
    // }
  }, []);

  return (
    <>
      <input
        ref={passwordRef}
        type="text"
        value={value}
        onChange={(e) => onChange(e)}
        name={name}
        className={`form-control password ${show ? 'show-password' : value ? '' : 'show-password'}`}
        placeholder={placeholder}
        autoFocus={true}
      />
      {showIcon && (
        <span className="input-group-text" id="basic-addon1">
          {show ? <BsEyeSlash onClick={() => setShow(false)} /> : <BsEye onClick={() => setShow(true)} />}
        </span>
      )}
    </>
  );
};

export default PasswordInput;
